import React,{useEffect, useState, useRef} from 'react';
import { url } from '../../../../../Config';
import axios from 'axios';
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { encryptParams } from '../../../encrypt_url';
import { Fab } from "@mui/material";
import { Popover } from "@material-ui/core";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreVertIcon from "@mui/icons-material/MoreVert";



export default function Analyst_detail(props) {

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [subTabbar, setsubTabbar] = React.useState(false);  
    const [rc_to_be_done_30_days, setrc_to_be_done_30_days] = useState([]);
    const [dd_to_be_done_30_days, setdd_to_be_done_30_days] = useState([]);
    const [ic_to_be_done_30_days, setic_to_be_done_30_days] = useState([]);
    const [fc_to_be_done_30_days, setfc_to_be_done_30_days] = useState([]);
    const [initial_clients, setinitial_clients] = useState([]);
    const [support_portfolio, setsupport_portfolio] = useState([]);
    const [analyst, setanalyst] = useState({});
    const { analyst_id } = useParams();


    
  function DateFormat(params) {
    if (params == null) {
      return "-";
    } else {
      const date = new Date(params);
      const yyyy = date.getFullYear();
      const yy = yyyy.toString();
      const y = yy.slice(2, 4);
      let mm = date.toLocaleString("default", { month: "short" });
      let dd = date.getDate();
      if (dd < 10) dd = "0" + dd;
      return dd + "-" + mm + "-" + y;
    }
  }


    const hideSubTabBar = () => {
        setsubTabbar(!subTabbar);
      };
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
        // setValue(event.target.newValue);
    };

    useEffect(()=>{

        const func = async ()=>{
            const res = await axios.get(`${url}/api/analyst_detail/${analyst_id}`);
            const resp = res.data;
            setanalyst(resp.analyst[0]);
            
            setrc_to_be_done_30_days(resp.rc_to_be_done_30_days);
            setdd_to_be_done_30_days(resp.dissemination_to_be_done_30_days);
            setic_to_be_done_30_days(resp.ic_to_be_done_30_days);
            setfc_to_be_done_30_days(resp.fc_to_be_done_30_days);
            setinitial_clients(resp.initial_clients);
            setsupport_portfolio(resp.support_portfolio);
        }

        func();

    },[])

  return (
    <div style={{height: '90vh'}}>
        <div className="mx-auto p-3 fs-3 fw-bold mb-0 text-capitalize" style={{ width: "fit-content", color:"#000078" }}>
            Analyst Details
        </div>
        <div className='card shadow col-11 mx-auto p-2 mt-2'>
            <div className='row mb-2'>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 row mb-1'>
                    <div className='col-4 col-lg-3 col-md-3 col-sm-4 fw-bold'>Name: </div>
                    <div className='col-8 col-lg-7 col-md-7 col-sm-7'>
                        <input className='form-control' value={analyst.display_name} disabled/>
                    </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 row mb-1'>
                    <div className='col-4 col-lg-3 col-md-3 col-sm-4 fw-bold'>Designation: </div>
                    <div className='col-8 col-lg-7 col-md-7 col-sm-7'>
                        <input className='form-control' value={analyst.Designation} disabled/>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 row mb-1'>
                    <div className='col-4 col-lg-3 col-md-3 col-sm-4 fw-bold'>Team Lead: </div>
                    <div className='col-8 col-lg-7 col-md-7 col-sm-7'>
                        <input className='form-control' value={analyst.team_lead} disabled/>
                    </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 row mb-1'>
                    <div className='col-4 col-lg-3 col-md-3 col-sm-4 fw-bold'>Email: </div>
                    <div className='col-8 col-lg-7 col-md-7 col-sm-7'>
                        <input className='form-control' value={analyst.email} disabled/>
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-auto p-3 fs-3 fw-bold mb-0 text-capitalize" style={{ width: "fit-content", color:"#000078" }}>
            Analyst Tasks (30 days)
        </div>
        <div className='mt-3 col-11 mx-auto'>
            <div className={`${classes.root}`}>
            {props.screenWidth > 770 ? (
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                className={`theme_text mb-4 pb-2`}
                aria-label="scrollable auto tabs example"
                style={{'overflowX': 'scroll'}}
            >
                <Tab label="Upcoming RC (30 Days)" {...a11yProps(0)} />
                <Tab label="Upcoming IC (30 Days)" {...a11yProps(1)} />
                <Tab label="Upcoming DD (30 Days)" {...a11yProps(2)} />
                <Tab label="Upcoming FC (30 Days)" {...a11yProps(3)} />
                <Tab label="Initial Clients" {...a11yProps(4)} />
            </Tabs>) :
            (
            <PopupState
            variant="popover"
            popupId="demo-popup-popover"
            className={`height_TabsBar ${classes.topMargin} ${
              props.open ? classes.leftMargin : classes.responsiveLeft
            }`}
            >
            {(popupState) => (
              <>
                <Fab
                 color="transparent"
                 aria-label="edit"
                 variant="extended"
                 className={`ms-2 fabCustom ${
                   (value === 8 && classes.topAbsoluteSubTabs) ||
                   (value === 2 && classes.topAbsoluteSubTabs) ||
                   (value === 3 && classes.topAbsoluteSubTabs) ||
                   (value === 4 && classes.topAbsoluteSubTabs) ||
                   (value === 5 && classes.topAbsoluteSubTabs) ||
                   (value === 6 && classes.topAbsoluteSubTabs) ||
                   classes.topAbsolute
                 }`}
               >
            <MoreVertIcon {...bindTrigger(popupState)} />
                </Fab>
                <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <Tabs
                value={value}
                onChange={handleChange}
                orientation="vertical"
                indicatorColor="primary"
                className={`theme_text mb-4 pb-2`}
                aria-label="scrollable auto tabs example"
            >
                <Tab label="Upcoming RC (30 Days)" {...a11yProps(0)} />
                <Tab label="Upcoming IC (30 Days)" {...a11yProps(1)} />
                <Tab label="Upcoming DD (30 Days)" {...a11yProps(2)} />
                <Tab label="Upcoming FC (30 Days)" {...a11yProps(3)} />
                <Tab label="Initial Clients" {...a11yProps(4)} />
            </Tabs>
                </Popover>
              </>
            )}
            </PopupState>

            )
            }            
            </div>
            <TabPanel value={value} index={0}>
                <div className='card shadow col-12 p-3'>
                    {
                        rc_to_be_done_30_days.map((value, index)=>{
                            const clientId = value.client_id;
                            const encryptedParams = encryptParams({clientId});
                            return(
                                <div>
                                    {index + 1}){"  "}<a href={`/OpinionDetails/${encryptedParams}`} target='_blank'>{value.opName}</a> | {DateFormat(value.rc_deadline)}
                                </div>
                            )
                        })
                    }
                </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <div className='card shadow col-12 p-3'>
                    {
                        ic_to_be_done_30_days.map((value, index)=>{
                            const clientId = value.client_id;
                            const encryptedParams = encryptParams({clientId});
                            return(
                                <div>
                                    {index + 1}){"  "}<a href={`/OpinionDetails/${encryptedParams}`} target='_blank'>{value.opName}</a> | {DateFormat(value.ic_deadline)}
                                </div>
                            )
                        })
                    }
                </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <div className='card shadow col-12 p-3'>
                    {
                        dd_to_be_done_30_days.map((value, index)=>{
                            const clientId = value.client_id;
                            const encryptedParams = encryptParams({clientId});
                            return(
                                <div>
                                    {index + 1}){"  "}<a href={`/OpinionDetails/${encryptedParams}`} target='_blank'>{value.opName}</a> | {DateFormat(value.dissemination_deadline)}
                                </div>
                            )
                        })
                    }
                </div>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <div className='card shadow col-12 p-3'>
                    {
                        fc_to_be_done_30_days.map((value, index)=>{
                            const clientId = value.client_id;
                            const encryptedParams = encryptParams({clientId});
                            return(
                                <div>
                                    {index + 1}){"  "}<a href={`/OpinionDetails/${encryptedParams}`} target='_blank'>{value.opName}</a> | {DateFormat(value.fc_deadline)}
                                </div>
                            )
                        })
                    }
                </div>
            </TabPanel>
            <TabPanel value={value} index={4}>
                <div className='card shadow col-12 p-3'>
                    {
                        initial_clients.map((value, index)=>{
                            const clientId = value.Id;
                            const encryptedParams = encryptParams({clientId});
                            return(
                                <div>
                                    {index + 1}){"  "}<a href={`/OpinionDetails/${encryptedParams}`} target='_blank'>{value.Entity}</a> | {DateFormat(value.Initiation)}
                                </div>
                            )
                        })
                    }
                </div>
            </TabPanel>
        </div>
    </div>
  )

}

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
        className={`card ${props.screenWidth > 770 ? "mt-4" : "negative_margin"}`}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }
  
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    topMargin: {
      top: "50px",
    },
    leftMargin: {
      width: `calc(100% - ${240}px)`,
    },
    left: {
      width: `calc(100% - ${74}px)`,
    },
    responsiveLeft: {
      width: "100%",
    },
    topAbsolute: {
      top: "4px",
    },
  }));
